---
type: guest
cover: 'https://media.codingcat.dev/image/upload/v1683038178/main-codingcatdev-photo/podcast-guest/laurieontech'
name: Laurie Barth
published: published
slug: laurie-barth
start: January 1, 2000
picks: https://www.notion.so/Code-Girls-book-about-female-code-breakers-during-WW-II-79b44bcdc2ec4bb08502300b5f66dd1a, https://www.notion.so/Drop-mechanical-keyboard-shop-10c08679d86742c4be18586468b58846
socials:
  devto: 'https://dev.to/laurieontech'
  github: 'https://github.com/laurieontech'
  linkedin: 'https://www.linkedin.com/in/lauriebarth/'
  polywork: 'https://timeline.laurieontech.com/'
  twitter: 'https://twitter.com/laurieontech'
websites:
  - https://laurieontech.com/
---

## About

Laurie is a senior software engineer at Netflix, but got her start as a mathematician. She does lots of content creation from courses on Egghead, to blog posts and podcasts. In her free time, you may find her building her latest LEGO masterpiece or playing with her dog, Avett.

I wanted to have Laurie on, because one, she is hilarious and makes me laugh every time I hear her on a podcast. And two, she is incredibly motivating for women in tech.
